module.exports = __webpack_public_path__ + "static/img/an2-mayor.64b6408.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/an2-mayor.png
// module id = wZ2s
// module chunks = 0